"use strict";
import { Token } from "@uniswap/sdk-core";
import { NATIVE_CHAIN_ID } from "constants/tokens";
import store from "state";
import { COMMON_BASES } from "constants/uniswapRouting";
import { nativeOnChain, getDexTokenList } from "constants/topazTokenList";
import { isSameAddress } from "utilities/src/addresses";
import { fetchTokenData } from "features/routing/api/bscSubgraph";
import { isBscChain } from "constants/bscContracts";
function findTokenInLoadedLists(address, chainId) {
  const listsByUrl = store.getState().lists.byUrl;
  for (const url of Object.keys(listsByUrl)) {
    const match = listsByUrl[url]?.current?.tokens.find(
      (token) => token.chainId === chainId && isSameAddress(token.address, address)
    );
    if (match) {
      return new Token(chainId, match.address, match.decimals, match.symbol, match.name);
    }
  }
  return void 0;
}
function findUserAddedToken(address, chainId) {
  const tokensByAddress = store.getState().user.tokens?.[chainId];
  const match = tokensByAddress ? Object.values(tokensByAddress).find((token) => isSameAddress(token.address, address)) : void 0;
  return match ? new Token(chainId, match.address, match.decimals, match.symbol, match.name) : void 0;
}
export async function getCurrency(currencyId, chainId) {
  const isNative = currencyId === NATIVE_CHAIN_ID || currencyId?.toLowerCase() === "native" || currencyId?.toLowerCase() === "eth";
  if (isNative) {
    return nativeOnChain(chainId);
  }
  const commonBase = chainId ? COMMON_BASES[chainId]?.find((base) => base.currency.isToken && isSameAddress(base.currency.address, currencyId)) : void 0;
  if (commonBase) {
    return commonBase.currency;
  }
  try {
    if (isBscChain(chainId)) {
      const knownTokens = getDexTokenList(chainId);
      const knownToken = knownTokens.find((token) => isSameAddress(token.address, currencyId));
      if (knownToken) {
        return knownToken;
      }
      const listedToken = findTokenInLoadedLists(currencyId, chainId) ?? findUserAddedToken(currencyId, chainId);
      if (listedToken) {
        return listedToken;
      }
      const tokenData = await fetchTokenData(currencyId);
      if (tokenData) {
        return new Token(
          chainId,
          currencyId,
          parseInt(tokenData.decimals),
          tokenData.symbol,
          tokenData.name
        );
      }
    }
    return void 0;
  } catch (error) {
    console.warn(`Failed to fetch token data for ${currencyId} on chain ${chainId}:`, error);
    return void 0;
  }
}
